define(
  'app/views/cart_view',['app/setup', 'app/views/cart_item_view'],
  function(takhfifan, cartItemView) {

  takhfifan.CartView = Backbone.View.extend({

    initialize: function(options) {
      this.cartType = this.$el.hasClass('has-gift') ? 'yadisa' :
                      this.$el.hasClass('has-product') ? 'products' : 'service';

      var productsDetail = this.$el.data('itemdetails'),
          gaCommands = [];

      _.each(productsDetail, function(product){
        gaCommands.push({
          command: "ec:addProduct",
          options: product
        });
      });

      if(gaCommands.length){
        var opts = {step: 1};
        if(this.$el.data('isgiftenabled')){
          opts.option = "gift"
        }
        gaCommands.push({
          command: "ec:setAction",
          param: "checkout",
          options:opts
        });
      }

      takhfifan.eventHub.trigger('ga:sendPageView', {
        title: "",
        path: this.cartType,
        commands: gaCommands
      });
    }

  });

  $('.tkh-cart').each(function(){
    var $this = $(this);
    new takhfifan.CartView({
      el: $this
    });
  });

});

